import strokeColorToFillColor from "./strokeColorToFillColor";
export default strokeColorToFillColor;